<app-modal #modal>

  <span title>{{"Media Lab"|translate}}</span>

  <div class="medias-wrapper" body>
    <div class="jewel-detail">

      <div class="header">
        @if(this.medias().length > 0){
        <button class="btn"
          [ngClass]="{'btn-primary': selectedMediaType() === MediaType.Video, 'btn-secondary':selectedMediaType() !== MediaType.Video}"
          (click)="selectedMediaType.set(MediaType.Video)">
          {{"Video"|translate}}
        </button>
        }
        @if(this.images().length > 0){
        <button class="btn"
          [ngClass]="{'btn-primary': selectedMediaType() === MediaType.Image, 'btn-secondary':selectedMediaType() !== MediaType.Image}"
          (click)="selectedMediaType.set(MediaType.Image)">
          {{"Photo"|translate}}
        </button>
        }
      </div>

      <div class="body container-fluid">
        <div class="row">
          <div class="col col-2">
            <app-media-selector [media]="covers" [selectedMedia]="selectedCover"
              (handleChangeMedia)="handleChangeMedia($event)"></app-media-selector>
          </div>
          <div class="col col-10">
            <div class="media-preview no-toolbar">

              <div class="media">

                @switch (selectedMediaType()) {

                @case (MediaType.Image){
                <img [attr.src]="selectedCover() || './../../assets/icons/start.svg'" alt="">
                }

                @case(MediaType.Video){
                @if(isOpenedModal()){
                <app-video [video]="selectedVideo()"></app-video>
                }
                }

                @default{
                <app-placeholder [message]="'No media available'|translate"></app-placeholder>
                }

                }

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div footer class="footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{"Close"|translate}}
    </button>
  </div>

</app-modal>
